(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('MyDomainNotification', MyDomainNotification)

    MyDomainNotification.$inject = ['$resource'];

    function MyDomainNotification($resource) {
        var resourceUrl = 'api/my-domain-notification';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                url: 'api/my-domain-notification/',
                method: 'GET',
            },
            'getOne': {
                url: 'api/my-domain-notification/find-one/:id',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getClone': {
                url: 'api/my-domain-notification/clone/:id',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'search': {
                method: 'POST',
                isArray: true
            },
            'myDomainNotifications': {
                method: 'GET',
                url: 'api/my-domain-notification/notification-status/:id/:type'
            },
            'insertDomainAlerts': {
                method: 'PUT',
                url: 'api/my-domain-notification/alert-configuration'
            },
            'update': {
                url: 'api/my-domain-notification',
                method: 'PUT'
            },
            'delete': {
                url: 'api/my-domain-notification/:id',
                method: 'DELETE'
            },
            'getCurrentUserProfile': {
                url: 'api/my-domain-notification/userProfile',
                method: 'GET'
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('AlertSystem', AlertSystem);

    AlertSystem.$inject = ['$resource'];

    function AlertSystem ($resource) {
        var resourceUrl =  'api/my-channel/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'userAlertSystem' : {
                method:'PUT' ,
                url:'api/my-channel-user'
            },
            'getUserAlertSystem' : {
                method:'GET' ,
                url:'api/my-channel-user/:user',
                isArray: true
            },
            'getSlackState' : {
                method:'GET' ,
                url:'api/slack/integration/state'
            },
            'checkSlackState' : {
                method:'GET' ,
                url:'api/slack/integration/status'
            },
            'sendSlackWelcome' : {
                method:'GET' ,
                url:'api/slack/integration/test'
            },
            'sendMailCode' : {
                method:'GET' ,
                url:'api/mail/integration?email=:email'
            },
            'checkMailCode' : {
                method:'GET' ,
                url:'api/mail/authorize?authorizationCode=:authorizationCode'
            },
            'checkTelegramCode' : {
                method:'GET' ,
                url:'api/telegram/authorize?authorizationCode=:authorizationCode'
            },
            'getAuthentications' : {
                method:'GET' ,
                url:'api/webhook/integration/authenticationType',
                isArray : true
            },
            'checkWebhook' : {
                method:'POST' ,
                url:'api/webhook/integration/test'
            },
            'saveWebhook' : {
                method:'GET' ,
                url:'api/webhook/integration/save'
            }
        });
    }
})();

